import type {
	LinksFunction,
	LoaderFunction,
	MetaFunction,
} from '@remix-run/node';

import { useLoaderData } from '@remix-run/react';

import { Banner } from '~/components/atoms/Banner/index.tsx';
import divider from '~/components/atoms/Divider/index.tsx';

import contentStylesUrl from '~/styles/content/content.css?url';

type TLoaderData = {
	divider: string;
};

export const links: LinksFunction = () => [
	{
		rel: 'stylesheet',
		href: contentStylesUrl,
	},
];

export const meta: MetaFunction = () => [
	{
		title: 'About GList',
	},
];

export const loader: LoaderFunction = async (): Promise<TLoaderData> => {
	const theDivider = divider();

	return {
		divider: theDivider,
	};
};

export default function About(): React.ReactNode {
	const { divider } = useLoaderData<TLoaderData>();
	return (
		<main id="main">
			<Banner title="About GList" />
			<div
				className="divider white"
				role="img"
				aria-label="Mountain-scape divider"
				aria-hidden="true"
				dangerouslySetInnerHTML={{ __html: divider }}
			/>
			<section className="container content-container-alt small-container">
				<h2>Our Mission</h2>
				<p>
					At our service, we aim to provide a user-friendly and
					collaborative environment where families, friends, and
					groups can effortlessly create, manage, and share gift lists
					for various events.
				</p>

				<h2>Key Features</h2>
				<p>Our service allows users to:</p>
				<ul>
					<li>
						Create multiple lists for different occasions such as
						Christmas, birthdays, and more.
					</li>
					<li>
						Form groups where members can collaborate and add their
						gift preferences.
					</li>
					<li>
						Invite others to join their groups/lists for seamless
						sharing and coordination.
					</li>
					<li>
						Manage accounts, group members, and list items with
						ease.
					</li>
				</ul>

				<h2>Upgrade Options</h2>
				<p>
					We offer different pricing tiers to accommodate varying
					needs:
				</p>
				<ul>
					<li>
						Free Tier: Includes the ability to create one group with
						up to 5 people.
					</li>
					<li>
						Premium Tiers: Unlock additional features such as
						multiple groups, expanded group capacity, advanced
						collaboration tools, customization options, and more.
					</li>
				</ul>

				<h2>Contact Us</h2>
				<p>
					If you have any questions, suggestions, or need assistance,
					please feel free to reach out to our support team at
					support@yourdomain.com.
				</p>
			</section>
		</main>
	);
}
